import { render, staticRenderFns } from "./CClassifiedThumbnail.vue?vue&type=template&id=4d3affaa&scoped=true&"
import script from "./CClassifiedThumbnail.vue?vue&type=script&lang=ts&"
export * from "./CClassifiedThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./CClassifiedThumbnail.vue?vue&type=style&index=0&id=4d3affaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3affaa",
  null
  
)

export default component.exports